import {fetchDelete, fetchGet, fetchPost, fetchPut} from './utils.js';
import LoginManager from '../libs/LoginManager';

const loginManager = LoginManager.getSharedInstance();

export async function login({venue_code, email, password}) {
  const res = await fetchPost({
    path: '/api/v1/auth/login',
    data: {
      venue_code,
      email,
      password,
    },
    params: {},
  });
  return res || null;
}

async function wrapRequireAuthAPI(fn, opts) {
  let res = null;
  try {
    console.log(opts);
    window.incrementLoading();
    res = await fn({
      ...opts,
      bearer: loginManager.accessToken,
    });

    if (res && res.info && res.info.token) {
      loginManager.setAccessToken(
          res.info.token.expires_in,
          res.info.token.access_token,
      );
    }
  } catch (e) {
    window.decrementLoading();
    if (e && e.response && e.response.status && e.response.status == 401) {
      console.log('Invalid token');
      loginManager.invalidTokenDetected();
      return null;
    }
    throw e;
  }
  window.decrementLoading();
  return res;
}

export async function getMyVenue() {
  let res = await wrapRequireAuthAPI(fetchGet, {
    path: '/api/v1/venues/current',
  });
  return (res && res.venue) || null;
}

export async function getMyRooms() {
  let res = await wrapRequireAuthAPI(fetchGet, {
    path: '/api/v1/rooms/',
  });
  return (res && res.rooms) || [];
}

export async function getMyRoomsForDashboard() {
  let res = await wrapRequireAuthAPI(fetchGet, {
    path: '/api/v1/rooms/dashboard',
  });
  return (res && res.rooms) || [];
}

export async function addNewRoom({name}) {
  let res = await wrapRequireAuthAPI(fetchPost, {
    path: '/api/v1/rooms/',
    data: {
      name,
    },
  });
  return res || null;
}

export async function changeDeviceRoom({device_id, room_id}) {
  let res = await wrapRequireAuthAPI(fetchPut, {
    path: `/api/v1/devices/${device_id}`,
    data: {
      room_id,
    },
  });
  return res || null;
}

export async function changeDeviceSerialCode({device_id, serial_code}) {
  let res = await wrapRequireAuthAPI(fetchPut, {
    path: `/api/v1/devices/${device_id}`,
    data: {
      serial_code,
    },
  });
  return res || null;
}

export async function getMyDevices() {
  let res = await wrapRequireAuthAPI(fetchGet, {
    path: '/api/v1/devices/',
  });
  return (res && res.devices) || [];
}

export async function deleteDevice({device_id}) {
  let res = await wrapRequireAuthAPI(fetchDelete, {
    path: `/api/v1/devices/${device_id}`,
  });
  return (res && res.devices) || [];
}

export async function addDevice({customer_id, room_id, serial_code = ''}) {
  let res = await wrapRequireAuthAPI(fetchPost, {
    path: '/api/v1/devices/',
    data: {
      customer_id,
      room_id,
      serial_code,
    },
  });
  return res || null;
}

export async function updateVenueAndRooms({venue, rooms}) {
  let res = await wrapRequireAuthAPI(fetchPut, {
    path: '/api/v1/venues/current',
    data: {
      venue,
      rooms,
    },
  });
  return (res && res.devices) || [];
}

export async function resendVenueCode({email}) {
  const res = await fetchPost({
    path: '/api/v1/auth/resend-venuecode',
    data: {
      email,
    },
    params: {},
  });
  return res || null;
}

export async function getRegistrationToken({email, password}) {
  const res = await fetchPost({
    path: '/api/v1/auth/registration-token',
    data: {
      email,
      password,
    },
    params: {},
  });
  return res || null;
}

export async function getScannedDeviceInfo({customer_id}) {
  const res = await fetchGet({
    path: '/api/v1/devices/info',
    data: {},
    params: {customer_id},
  });
  return (res && res.device) || null;
}

export async function getScannedDeviceInfoWithAuth({customer_id}) {
  let res = await wrapRequireAuthAPI(fetchGet, {
    path: '/api/v1/devices/info',
    data: {},
    params: {customer_id},
  });
  return (res && res.device) || null;
}

export async function getCountryMaster() {
  const res = await fetchGet({
    path: '/api/v1/countries',
    data: {},
    params: {},
  });
  return (res && res.countries) || [];
}

export async function getViewerInfo() {
  const res = await fetchGet({
    path: '/api/v1/auth/viewer-info',
    data: {},
    params: {},
  });
  return (res && res.viewer) || null;
}

export async function registerVenue({data, registrationToken}) {
  const res = await fetchPost({
    path: '/api/v1/venues/register',
    data,
    params: {},
    bearer: registrationToken,
  });
  return res || null;
}

export async function getMyEvents({offset, limit, asc}) {
  let res = await wrapRequireAuthAPI(fetchGet, {
    path: '/api/v1/events/',
    params: {
      offset,
      limit,
      asc,
      _: Date.now(),
    },
  });
  return res || {events: [], total: 0};
}

export async function getEventDetail({event_id}) {
  let res = await wrapRequireAuthAPI(fetchGet, {
    path: `/api/v1/events/${event_id}`,
    params: {
      _: Date.now(),
    },
  });
  return res || null;
}

export async function sendInquiryAuth({category, description}) {
  let res = await wrapRequireAuthAPI(fetchPost, {
    path: `/api/v1/contacts`,
    data: {
      category,
      description,
    },
  });
  return res || null;
}

export async function sendInquiry({name, email, category, description}) {
  const res = await fetchPost({
    path: `/api/v1/contacts`,
    data: {
      name,
      email,
      category,
      description,
    },
  });
  return res || null;
}

export async function getVenueSummary({year, month}) {
  let res = await wrapRequireAuthAPI(fetchGet, {
    path: `/api/v1/reports/summary`,
    params: {
      year,
      month,
    },
  });
  return (res && res.summary) || null;
}

export async function getVenueReport({
  year,
  month,
  previous_month_date_limit = 0,
}) {
  let res = await wrapRequireAuthAPI(fetchGet, {
    path: `/api/v1/reports/period2`,
    params: {
      year,
      month,
      previous_month_date_limit,
    },
  });
  return (res && res.summary) || null;
}

export async function getVenueChart({
  from,
  to,
}) {
  let res = await wrapRequireAuthAPI(fetchGet, {
    path: `/api/v1/reports/chart`,
    params: {
      from,
      to,
    },
  });
  return (res && res.chart) || null;
}

export async function getVenueTracks({year, month}) {
  let res = await wrapRequireAuthAPI(fetchGet, {
    path: `/api/v1/reports/tracks`,
    params: {
      year,
      month,
    },
  });
  return (res && res.items) || [];
}

const sampleNewsResponse = {
  'venuenews': [
    {
      'description_en': {
        'ops': [
          {
            'insert': 'rekordbox ver. 6.6.7 has been released.\nNov. 16, 2022\n',
          },
          {
            'attributes': {
              'bold': true,
            },
            'insert': 'release notes',
          },
          {
            'insert': '\n',
          },
          {
            'attributes': {
              'bold': true,
            },
            'insert': 'FIXED',
          },
          {
            'insert': '\nBug fixes and stability improvements.',
          },
          {
            'attributes': {
              'list': 'bullet',
            },
            'insert': '\n',
          },
        ],
      },
      'venuenews_id': 7,
      'display_datetime': '2022-11-16T00:00:00+00:00',
      'title_en': '[for test] rekordbox ver. 6.6.7 has been released. [for test] rekordbox ver. 6.6.7 has been released.',
      'link': 'https://rekordbox.com/en/2022/11/rekordbox-v667-release-information/',
      'link_label': '',
      'link2': 'https://rekordbox.com/en/',
      'link2_label': '',
      'link3': '',
      'link3_label': '',
    },
    {
      'description_en': {
        'ops': [
          {
            'insert': 'Thank you for using Pioneer DJ products. We\'ve finished researching the compatibility of our mobile apps with iOS 16 and iPadOS 16.\n\n*Full functionality is not guaranteed with iOS 16 or iPadOS 16.\n*Visit the Apple website for more information about ',
          },
          {
            'attributes': {
              'link': 'https://www.apple.com/ios/ios-16/',
            },
            'insert': 'iOS 16',
          },
          {
            'insert': ' and ',
          },
          {
            'attributes': {
              'link': 'https://www.apple.com/ipados/ipados-16/',
            },
            'insert': 'iPadOS 16',
          },
          {
            'insert': '.\n\n',
          },
        ],
      },
      'venuenews_id': 6,
      'display_datetime': '2022-11-15T00:00:00+00:00',
      'title_en': '[for test] Mobile app compatibility with iOS 16 and iPadOS 16',
      'link': 'https://www.pioneerdj.com/en-us/news/2022/mobile-app-compatibility-with-ios-16-and-ipados-16/',
      'link_label': '',
      'link2': '',
      'link2_label': '',
      'link3': '',
      'link3_label': '',
    },
  ],
  'result': true,
  'code': 0,
  'info': {
    'total_ms': 4,
    'ex_api_ms': 0,
  },
};

let sampleNews = false;

export async function getLatestVenueNews() {
  const res = await fetchGet({
    path: '/api/v1/venuenews',
    data: {},
    params: {
      limit: 1,
      title: 1,
    },
  });

  if (sampleNews) {
    return sampleNewsResponse.venuenews[0];
  } else {
    return (res && res.venuenews && res.venuenews.length && res.venuenews[0]) ||
        null;
  }
}

export async function getVenueNewsAll() {
  const res = await fetchGet({
    path: '/api/v1/venuenews',
    data: {},
    params: {
      offset: 0,
      limit: 100,
    },
  });

  if (sampleNews) {
    return sampleNewsResponse.venuenews;
  } else {
    return (res && res.venuenews) || [];
  }
}

export async function getAllFAQs() {
  const res = await fetchPost({
    path: '/api/v1/faqs/search',
    data: {
      categories: ['venue'],
    },
    params: {},
  });
  return res && res.faqs || [];
}

const sampleNowPlayingResponse = {
  tracks: [
    {
      title: 'Test Ttle Title Title',
      artist: 'Artist Name',
      played_ms: 1693988848361,
      played_local_datetime: '2023-09-06T12:34:56',
      room: {name: 'MAIN'},
    },
    {
      title: 'Test Ttle Title Title',
      artist: 'Artist Name',
      played_ms: 1693988848361,
      played_local_datetime: '2023-09-06T12:34:56',
      room: {name: 'MAIN'},
    },
    {
      title: 'Test Ttle Title Title',
      artist: 'Artist Name',
      played_ms: 1693988848361,
      played_local_datetime: '2023-09-06T12:34:56',
      room: {name: 'MAIN'},
    },
    {
      title: 'Test Ttle Title Title',
      artist: 'Artist Name',
      played_ms: 1693988848361,
      played_local_datetime: '2023-09-06T12:34:56',
      room: {name: 'MAIN'},
    },
    {
      title: 'Test Ttle Title Title',
      artist: 'Artist Name',
      played_ms: 1693988848361,
      played_local_datetime: '2023-09-06T12:34:56',
      room: {name: 'MAIN'},
    },
    {
      title: 'Test Ttle Title Title',
      artist: 'Artist Name',
      played_ms: 1693988848361,
      played_local_datetime: '2023-09-06T12:34:56',
      room: {name: 'MAIN'},
    },
    {
      title: 'Test Ttle Title Title',
      artist: 'Artist Name',
      played_ms: 1693988848361,
      played_local_datetime: '2023-09-06T12:34:56',
      room: {name: 'MAIN'},
    },
    {
      title: 'Test Ttle Title Title',
      artist: 'Artist Name',
      played_ms: 1693988848361,
      played_local_datetime: '2023-09-06T12:34:56',
      room: {name: 'MAIN'},
    },
    {
      title: 'Test Ttle Title Title',
      artist: 'Artist Name',
      played_ms: 1693988848361,
      played_local_datetime: '2023-09-06T12:34:56',
      room: {name: 'MAIN'},
    },
    {
      title: 'Test Ttle Title Title',
      artist: 'Artist Name',
      played_ms: 1693988848361,
      played_local_datetime: '2023-09-06T12:34:56',
      room: {name: 'MAIN'},
    },
    {
      title: 'Test Ttle Title Title',
      artist: 'Artist Name',
      played_ms: 1693988848361,
      played_local_datetime: '2023-09-06T12:34:56',
      room: {name: 'MAIN'},
    },
  ],
};

let sampleNowPlaying = false;

export async function getNowPlayingTracks() {
  let res = await wrapRequireAuthAPI(fetchGet, {
    path: '/api/v1/events/tracks/now-playing',
    params: {
      _: Date.now(),
      //debug: 1
    },
  });

  if (sampleNowPlaying) {
    return sampleNowPlayingResponse;
  }

  return res || {tracks: []};
}

export async function getRoomTracks() {
  let res = await wrapRequireAuthAPI(fetchGet, {
    path: '/api/v1/events/tracks/by-room',
    params: {
      _: Date.now(),
    },
  });
  return res || {rooms: []};
}